import PaymentMethodType from "./PaymentMethodType";
import CardIcon from "../../../../assets/images/CardIcon.png";
import Klarna from "../../../../assets/images/Klarna.png";
import ApplePay from "../../../../assets/images/ApplePay.png";
import GooglePay from "../../../../assets/images/GooglePay.png";
import IDEAL from "../../../../assets/images/IDEAL.png";
import MOBILEPAY from "../../../../assets/images/MOBILEPAY.png";
import SWISH from "../../../../assets/images/SWISHPAY.png";
import REVOLUT from "../../../../assets/images/REVOLUT.png";
import PAYPAL from "../../../../assets/images/PAYPAL.png";
import { paymentMethods, paymentTypeNames } from "../../../../utils/helperFunctions";
import { useContext, useRef, useState } from "react";
import ScrollButtons from "./ScrollButtons";
import LayoutContext from "../../../../contexts/LayoutContext";
import { useShowSocialPayment } from "../../../../utils/payments";

const PaymentTypes = ({ toggleButton }) => {
    const { selectedPaymentType, setSelectedPaymentType } = useContext(LayoutContext);
    const containerRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const { checkPaymentMethods } = useShowSocialPayment();
    const handleSelection = type => {
        setSelectedPaymentType(type);
    };

    const scrollContainer = direction => {
        if (containerRef.current) {
            const scrollAmount = 100;
            containerRef.current.scrollBy({
                left: direction === "left" ? -scrollAmount : scrollAmount,
                behavior: "smooth"
            });
        }
    };

    const checkScrollButtons = () => {
        if (containerRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = containerRef.current;
            setCanScrollLeft(scrollLeft > 0);
            setCanScrollRight(Math.ceil(scrollLeft + clientWidth) < scrollWidth);
        }
    };

    return (
        <div style={{ position: "relative", width: "100%" }}>
            {canScrollLeft && !toggleButton && (
                <ScrollButtons
                    className="fa-light fa-chevron-left"
                    scrollContainer={scrollContainer}
                    side={"left"}
                    style={{
                        position: "absolute",
                        left: 0,
                        zIndex: 10,
                        fontSize: "20px",
                        cursor: "pointer",
                        height: "100%",
                        top: 0,
                        display: "flex",
                        alignItems: "center",
                        background: "linear-gradient(270deg, rgba(18, 18, 18, 0) 0%, #121212 76%)"
                    }}
                />
            )}

            <div
                className="w-100"
                ref={containerRef}
                style={{
                    display: "flex",
                    overflow: toggleButton ? "visible" : "auto",
                    flexWrap: toggleButton && "wrap",
                    gap: "7px",
                    scrollBehavior: "smooth"
                }}
                onScroll={checkScrollButtons}>
                <PaymentMethodType
                    name={paymentTypeNames.CARD}
                    icon={CardIcon}
                    isSelected={selectedPaymentType === paymentMethods.CARD}
                    onClick={() => handleSelection(paymentMethods.CARD)}
                />
                <PaymentMethodType
                    name={paymentTypeNames.KLARNA_PAY}
                    icon={Klarna}
                    isSelected={selectedPaymentType === paymentMethods.KLARNA_PAY}
                    onClick={() => handleSelection(paymentMethods.KLARNA_PAY)}
                />
                {checkPaymentMethods?.applePay ? (
                    <PaymentMethodType
                        name={paymentTypeNames.APPLE_PAY}
                        icon={ApplePay}
                        isSelected={selectedPaymentType === paymentMethods.APPLE_PAY}
                        onClick={() => handleSelection(paymentMethods.APPLE_PAY)}
                    />
                ) : null}
                {checkPaymentMethods?.googlePay ? (
                    <PaymentMethodType
                        name={paymentTypeNames.GOOGLE_PAY}
                        icon={GooglePay}
                        isSelected={selectedPaymentType === paymentMethods.GOOGLE_PAY}
                        onClick={() => handleSelection(paymentMethods.GOOGLE_PAY)}
                    />
                ) : null}
            </div>

            {canScrollRight && !toggleButton && (
                <ScrollButtons
                    className="fa-light fa-chevron-right"
                    scrollContainer={scrollContainer}
                    side={"right"}
                    style={{
                        position: "absolute",
                        right: 0,
                        zIndex: 10,
                        fontSize: "20px",
                        cursor: "pointer",
                        height: "100%",
                        top: 0,
                        display: "flex",
                        alignItems: "center",
                        background: "linear-gradient(270deg, #121212 0%, rgba(18, 18, 18, 0) 76%)"
                    }}
                />
            )}
        </div>
    );
};

export default PaymentTypes;
